<template>
  <el-aside class="con-left un-select-background">
    <div
      :class="item.select ? 'cell select-background' : 'cell'"
      v-for="(item, index) in menuList"
      :key="index"
      @click="clickMenu(item.id)"
    >
      <span>{{ item.label }}</span>
    </div>
  </el-aside>
</template>

<script>
/* eslint-disable */

export default {
  name: 'asideBody',
  data() {
    return {
      menuList: [
        {
          id: 0,
          label: '文章管理',
          path: '/reports',
          select: true
        },
        {
          id: 1,
          label: '调查问卷管理',
          path: '/question',
          select: false
        },
        {
          id: 2,
          label: '预约检测统计',
          path: '/book',
          select: false
        },
        {
          id: 3,
          label: '网站访问量统计',
          path: '/visits',
          select: false
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.menuList.forEach(item => {
        if (this.$route.fullPath === item.path) {
          item.select = true
        } else {
          item.select = false
        }
      })
    })
  },
  methods: {
    clickMenu(id) {
      // console.log(id);
      this.$router.push({ path: this.menuList[id].path })
      for (const i in this.menuList) {
        if (parseInt(i) === id) {
          this.menuList[i].select = true
        } else {
          this.menuList[i].select = false
        }
      }
    }
  }
}
</script>

<style scoped>
.con-left {
  width: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.con-center {
  justify-content: center;
}

.con-padding {
  padding: 0 4px;
}

.con-start {
  justify-content: flex-start;
}

.span {
  font-weight: bold;
  color: #ffffff;
}

.un-select-background {
  background: rgba(0, 123, 255, 0.7);
}

.select-background {
  background: rgba(255, 255, 255, 0.4);
}

.cell {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
}
</style>
